<template>
    <div id="dashboard">
        <div class="item-list">
            <div v-for="(tile, idx) in tiles" :key=idx>
                <ItemRow :tile=tile> </ItemRow>
            </div>
        </div>
    </div>
</template>

<script>
    import ItemRow from './ItemRow'
    import { mapState } from 'vuex'
    const fb = require('../firebaseConfig.js')

    export default {
        components: { ItemRow },
        computed: {
            ...mapState(['tiles'])
        }
    }
</script>





// WEBPACK FOOTER //
// src/components/Dashboard.vue